import { FC } from "react";

import { ControlledTextArea } from "@/components/FormInputs";

const ChessPieceSelectorInput = ({
    selected,
    setSelected,
    description,
    setDescription,
}: {
    selected: string | null;
    setSelected: (selected: string) => void;
    description: string;
    setDescription: (description: string) => void;
}) => (
    <div className="flex flex-col space-y-4">
        <DrawChessBoard selected={selected} setSelected={setSelected} />
        <div className="flex flex-col">
            <ControlledTextArea
                label="Description"
                id={description}
                placeholder="Why?"
                value={description}
                onValue={name => setDescription(name)}
                required
            />
        </div>
    </div>
);

export default ChessPieceSelectorInput;

const rows = ["8", "7", "2", "1"];
const cols = ["a", "b", "c", "d", "e", "f", "g", "h"];

const DrawChessBoard: FC<{
    selected: string | null;
    setSelected: (sel: string) => void;
}> = ({ selected, setSelected }) => {
    return (
        <div className="grid w-full grid-cols-8 grid-rows-4">
            {rows.map((r, i) =>
                cols.map((c, n) => {
                    const whiteBackground = (i + n) % 2 == 0;
                    const el = `${c}${r}`;
                    return (
                        <div
                            key={el}
                            className={`flex aspect-square h-full w-full cursor-pointer items-center justify-center ${el == selected ? "bg-brand-yellow" : whiteBackground ? "bg-themed-light" : "bg-themed-medium"}`}
                            onClick={() => setSelected(el)}
                        >
                            <PositionToImg pos={el} />
                        </div>
                    );
                })
            )}
        </div>
    );
};

const PositionToImg: FC<{ pos: string }> = ({ pos }) => {
    switch (pos) {
        case "a1":
            return <img className="w-3/4" src="/pieces/wr.png" />;
        case "b1":
            return <img className="w-3/4" src="/pieces/wn.png" />;
        case "c1":
            return <img className="w-3/4" src="/pieces/wb.png" />;
        case "d1":
            return <img className="w-3/4" src="/pieces/wq.png" />;
        case "e1":
            return <img className="w-3/4" src="/pieces/wk.png" />;
        case "f1":
            return <img className="w-3/4" src="/pieces/wb.png" />;
        case "g1":
            return <img className="w-3/4" src="/pieces/wn.png" />;
        case "h1":
            return <img className="w-3/4" src="/pieces/wr.png" />;
        case "a2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "b2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "c2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "d2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "e2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "f2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "g2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "h2":
            return <img className="w-3/4" src="/pieces/wp.png" />;
        case "a8":
            return <img className="w-3/4" src="/pieces/br.png" />;
        case "b8":
            return <img className="w-3/4" src="/pieces/bn.png" />;
        case "c8":
            return <img className="w-3/4" src="/pieces/bb.png" />;
        case "d8":
            return <img className="w-3/4" src="/pieces/bq.png" />;
        case "e8":
            return <img className="w-3/4" src="/pieces/bk.png" />;
        case "f8":
            return <img className="w-3/4" src="/pieces/bb.png" />;
        case "g8":
            return <img className="w-3/4" src="/pieces/bn.png" />;
        case "h8":
            return <img className="w-3/4" src="/pieces/br.png" />;
        case "a7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
        case "b7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
        case "c7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
        case "d7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
        case "e7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
        case "f7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
        case "g7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
        case "h7":
            return <img className="w-3/4" src="/pieces/bp.png" />;
    }
};

/*const PositionToPieceMapping = (pos: string) => {
  switch (pos) {
    case "b1":
      return "White queen-side knight";
    case "c1":
      return "White queen-side bishop";
    case "d1":
      return "White queen";
    case "e1":
      return "White king";
    case "f1":
      return "White king-side bishop";
    case "g1":
      return "White king-side knight";
    case "h1":
      return "White king-side rook";
    case "a2":
      return "White a-pawn";
    case "b2":
      return "White b-pawn";
    case "c2":
      return "White c-pawn";
    case "d2":
      return "White d-pawn";
    case "e2":
      return "White e-pawn";
    case "f2":
      return "White f-pawn";
    case "g2":
      return "White g-pawn";
    case "h2":
      return "White h-pawn";
    case "a8":
      return "Black queen-side rook";
    case "b8":
      return "Black queen-side knight";
    case "c8":
      return "Black queen-side bishop";
    case "d8":
      return "Black queen";
    case "e8":
      return "Black king";
    case "f8":
      return "Black king-side bishop";
    case "g8":
      return "Black king-side knight";
    case "h8":
      return "Black king-side rook";
    case "a7":
      return "Black a-pawn";
    case "b7":
      return "Black b-pawn";
    case "c7":
      return "Black c-pawn";
    case "d7":
      return "Black d-pawn";
    case "e7":
      return "Black e-pawn";
    case "f7":
      return "Black f-pawn";
    case "g7":
      return "Black g-pawn";
    case "h7":
      return "Black h-pawn";
  }
};*/
